<template lang="pug">
    PrintablePanel
      ICEAlert
      PageHeader.multi-id-header Multiple ID Search Results
      .row.purchasers-panel.body-2
        .col
          h3 Purchasers
          span.id-label Identification Numbers:
          .mb-2.id-numbers
            span(v-for="id of idNumbers")
              | &nbsp;{{ id }}
              br
          br
          span Date Range:
            strong &nbsp;{{ startDate }} - {{ endDate }}
        .col-lg-1(v-if="!printable")
          router-link.btn.btn-primary(:to="{query: {print: true}}" target="_blank") Print
      .row.search-row(v-if="!printable")
        SearchBar.body-1(v-model="filterText")
      .row.mt-3.mr-0
        .col
          Datatable(:columns="transactionTypeColumns"
                    :entries="[1]"
                    :footer="false")
            tr(slot-scope="props")
              td.body-3.p-1 {{ transactionEntries.length }}
              td.body-3.p-1 {{ counts.purchases }}
              td.body-3.p-1 {{ counts.blocks }}
              td.body-3.p-1 {{ counts.exceedances }}
              td.body-3.p-1 {{ counts.returns }}
      .row.mt-3.mr-0
        .col-12
          p
            | Note: Transactions occurring on the same day are visually grouped by a dark gray outline (
            span.outline-key
            | ).
        .col-12
          Datatable(:entries="filteredEntries"
                    :column-count="8"
                    :per-page="10"
                    :footer="filteredEntries.length > 10")
            template(slot="header")
              th.h7 Transaction Date/Time
              th.h7
                div Transaction ID(s)
                div (N)PLEx
                div (S)tore
              th.h7 Name/ID
              th.h7 Transaction Type
              th.h7 Product(s)
              th.h7 Grams
              th.h7 Box(es)
              th.h7 Store
            template(slot-scope="props")
              tr.date-border(:class="{first: props.entry.first}")
                td.body-3 {{ props.entry.transactionDt }}
                td.body-3
                  div (N) {{ props.entry.transactionSid }}
                  div (S) {{ props.entry.pharmacyTrxId || 'N/A' }}
                td.body-3
                  div {{ props.entry.lastName }}, {{ props.entry.firstName}}
                  div {{ props.entry.idNbr }}
                td.body-3 {{ props.entry.transactionCd }}
                td.body-3
                  div(v-for="product in props.entry.products") {{ product }}
                td.body-3 {{ props.entry.grams }}
                td.body-3 {{ props.entry.boxes }}
                td.body-3
                  div {{ props.entry.pharmacyName }}
                  div {{ props.entry.pharmacyPhone }}
                  div {{ props.entry.pharmacyAddress1 }}
                  div {{ props.entry.pharmacyAddress2 }}
                  div {{ props.entry.pharmacyCity }}, {{ props.entry.pharmacyStateCd }} {{ props.entry.pharmacyPostalCode }}
</template>

<script>
import PageHeader from '@/components/PageHeader'
import PrintablePanel from '@/components/PrintablePanel'
import SearchBar from '@/components/SearchBar'
import Datatable from '@/components/Datatable'
import axios from '@/lib/axios'
import { formItem, clearForm } from '@/lib/formstore'
import { globalError } from '@/lib/utils'

export default {
  name: 'MultipleIdResults',
  data: function() {
    return {
      transactionTypeColumns: [
        'All Activity',
        'Purchases',
        'Blocks',
        'Exceedances',
        'Returns',
      ],
      transactionEntries: [],
      filterText: '',
      startDate: '',
      endDate: '',
      idNumbers: [],
    }
  },
  computed: {
    counts() {
      return {
        purchases: this.transactionEntries.reduce(
          (acc, v) => acc + (v.transactionCd === 'Purchase' ? 1 : 0),
          0,
        ),
        blocks: this.transactionEntries.reduce(
          (acc, v) => acc + (v.transactionCd === 'Block' ? 1 : 0),
          0,
        ),
        exceedances: this.transactionEntries.reduce(
          (acc, v) => acc + (v.transactionCd === 'Exceedance' ? 1 : 0),
          0,
        ),
        returns: this.transactionEntries.reduce(
          (acc, v) => acc + (v.transactionCd === 'Return' ? 1 : 0),
          0,
        ),
      }
    },
    filteredEntries: function() {
      let dt = ''
      let filtered = this.transactionEntries.slice(0) // copy array

      // Make each each one that is the "first" of its date (for styling purposes)
      filtered.forEach(trans => {
        let trx_dt = trans.transactionDt.split(' ')[0]
        if (trx_dt !== dt) {
          trans.first = true
          dt = trx_dt
        }
      })

      return filtered.filter(tx => {
        for (let val of Object.values(tx)) {
          if (
            val &&
            val
              .toString()
              .toLowerCase()
              .includes(this.filterText.toLowerCase())
          )
            return true
        }
        return false
      })
    },
  },
  async beforeRouteEnter(to, from, next) {
    try {
      let resp = await axios().get('/api/reports/link', {
        params: { id: to.params.id },
      })
      next(vm => {
        vm.transactionEntries = resp.data.results
        vm.startDate = resp.data.criteria.startDate
        vm.endDate = resp.data.criteria.endDate
        vm.idNumbers = resp.data.criteria.idNumbers
        if (vm.printable) vm.$nextTick(() => window.print())
      })
    } catch (err) {
      globalError(err)
    }
  },
  beforeRouteLeave(_to, _from, next) {
    clearForm('multipleid')
    next()
  },
  components: {
    PageHeader,
    SearchBar,
    Datatable,
    PrintablePanel,
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/breakpoints';

.panel-white {
  width: 1007px;
}

.row {
  margin-left: 1rem;
  margin-right: 1rem;
}

.search-row {
  flex-direction: row-reverse;
}

.purchasers-panel {
  border: 1px solid #e6e6e6;
  padding: 1rem;
  // margin-left: 0.1rem;
  // margin-right: 1rem;
}

.multi-id-header {
  margin-right: 1rem;
  margin-left: 1rem;
}

.id-label {
  vertical-align: top;
}

.id-numbers {
  font-weight: bold;
  display: inline-block;
}

.outline-key {
  border: 3px solid #707070;
  height: 0;
  width: 3rem;
  display: inline-block;
}

.date-border {
  td:first-child {
    box-shadow: inset 3px 0 #707070;
  }
  td:last-child {
    box-shadow: inset -3px 0 #707070;
  }
}
.date-border.first {
  td {
    border-top: 3px solid #707070;
  }
}

.date-border:first-child {
  td {
    border-top: 3px solid #707070;
  }
}

.date-border:last-child {
  td {
    border-bottom: 3px solid #707070;
  }
}
</style>
